import { SmartusComponentsModule } from '@affinis/smartus-components';
import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-chapter',
  imports: [SmartusComponentsModule, MatTooltipModule, FormlyModule],
  template: `
    @if (field.props?.chapterHr) {
      <hr />
    }
    <h3
      [innerText]="field.props?.chapterTitle || ''"
      #tooltip="matTooltip"
      [matTooltip]="field.props?.tooltip"
    ></h3>
    @if (field.props?.tooltip) {
      <su-button
        [skin]="'accent'"
        [icon]="'question-circle'"
        (onClick)="tooltip.toggle()"
      ></su-button>
    }
    <p [innerText]="field.props?.chapterText || ''"></p>
    @for (f of field.fieldGroup; track f) {
      <formly-field [field]="f"></formly-field>
    }
  `,
})
export class FormlyChapterComponent extends FieldType {}
